export const categories = [
  { slug: 'all', name: '全部漫画', icon: 'ri-apps-line' },
  { slug: 'romance', name: '浪漫爱情', icon: 'ri-heart-line' },
  { slug: 'fantasy', name: '奇幻冒险', icon: 'ri-magic-line' },
  { slug: 'action', name: '热血动作', icon: 'ri-fire-line' },
  { slug: 'drama', name: '都市剧情', icon: 'ri-building-line' },
  { slug: 'thriller', name: '悬疑惊悚', icon: 'ri-ghost-line' },
  { slug: 'comedy', name: '搞笑日常', icon: 'ri-emotion-laugh-line' },
  { slug: 'historical', name: '古风穿越', icon: 'ri-history-line' },
];

export const comics = [
  {
    id: 1,
    title: '恶女的审判',
    author: '金智慧',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20beautiful%20Korean%20manhwa%20style%20illustration%20of%20an%20elegant%20noblewoman%20with%20long%20dark%20hair%20in%20a%20vintage%20gown%2C%20dramatic%20lighting%2C%20soft%20warm%20tones%2C%20romance%20genre%20cover%20art%2C%20clean%20simple%20soft%20gradient%20background&width=800&height=1100&seq=comic-01&orientation=portrait',
    description: '被冤枉杀害亲夫的贵族小姐李秀雅，在死刑执行前获得了回到过去的机会。这一次，她决定不再做任人宰割的羔羊，而是要揭开真相，让真正的罪人付出代价。一场关于复仇与救赎的故事就此展开。',
    rating: 9.5,
    views: 1280000,
    chapters: 86,
    status: '连载中',
    tags: ['复仇', '穿越', '宫廷', '女性向'],
    updated: '2026-08-04',
    featured: true,
    trending: true,
  },
  {
    id: 2,
    title: '剑与魔法之歌',
    author: '朴星辰',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20warrior%20holding%20a%20glowing%20sword%20in%20a%20magical%20realm%2C%20epic%20fantasy%20atmosphere%2C%20dramatic%20composition%2C%20clean%20simple%20soft%20gradient%20background%20with%20magical%20sparks&width=800&height=1100&seq=comic-02&orientation=portrait',
    description: '平凡的大学生金俊昊意外穿越到剑与魔法的世界，成为了预言中拯救王国的勇者。在这个充满危险与奇遇的异世界，他将与伙伴们一起踏上对抗黑暗势力的史诗冒险。',
    rating: 9.3,
    views: 980000,
    chapters: 124,
    status: '连载中',
    tags: ['异世界', '冒险', '魔法', '热血'],
    updated: '2026-08-04',
    featured: true,
    trending: true,
  },
  {
    id: 3,
    title: '办公室密语',
    author: '崔恩熙',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20two%20young%20professionals%20in%20modern%20office%20attire%20with%20romantic%20tension%2C%20contemporary%20urban%20setting%2C%20clean%20simple%20soft%20gradient%20background%2C%20drama%20romance%20genre&width=800&height=1100&seq=comic-03&orientation=portrait',
    description: '顶尖广告公司的两位创意总监——冷静理智的韩智浩与热情率真的尹瑞琳，在竞争激烈的职场中从针锋相对到相互吸引。办公室恋情、职场竞争、创意碰撞，演绎一段令人心动的都市爱情故事。',
    rating: 9.1,
    views: 756000,
    chapters: 62,
    status: '连载中',
    tags: ['职场', '恋爱', '都市', '治愈'],
    updated: '2026-08-03',
    featured: true,
    trending: true,
  },
  {
    id: 4,
    title: '暗夜追踪者',
    author: '姜太宇',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20detective%20in%20a%20dark%20alley%20at%20night%2C%20suspenseful%20atmosphere%2C%20dramatic%20shadows%2C%20clean%20simple%20dark%20gradient%20background%2C%20thriller%20genre&width=800&height=1100&seq=comic-04&orientation=portrait',
    description: '连环杀人案震惊全城，退休刑警朴正泰被迫重返一线。每一个线索都指向十年前的一桩悬案，而真相远比想象中更加黑暗。当正义与复仇的界限变得模糊，他将如何抉择？',
    rating: 9.4,
    views: 890000,
    chapters: 48,
    status: '连载中',
    tags: ['悬疑', '推理', '犯罪', '暗黑'],
    updated: '2026-08-02',
    featured: true,
    trending: false,
  },
  {
    id: 5,
    title: '我的同桌是校霸',
    author: '李美英',
    category: 'comedy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20two%20high%20school%20students%2C%20one%20tough%20looking%20and%20one%20shy%2C%20sitting%20at%20a%20school%20desk%2C%20comedic%20vibe%2C%20bright%20and%20cheerful%2C%20clean%20simple%20soft%20gradient%20background&width=800&height=1100&seq=comic-05&orientation=portrait',
    description: '品学兼优的乖乖女林小月被安排与全校最令人闻风丧胆的校霸陈浩宇做同桌。原以为会是一场噩梦，却发现这个看似凶狠的男生其实有着出人意料的温柔一面。爆笑又温馨的校园日常就此上演！',
    rating: 9.0,
    views: 1020000,
    chapters: 95,
    status: '连载中',
    tags: ['校园', '搞笑', '恋爱', '日常'],
    updated: '2026-08-04',
    featured: false,
    trending: true,
  },
  {
    id: 6,
    title: '倾城公主',
    author: '韩素希',
    category: 'historical',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20beautiful%20princess%20in%20traditional%20Korean%20hanbok%20in%20an%20ancient%20palace%20garden%2C%20historical%20romance%2C%20elegant%20and%20graceful%2C%20clean%20simple%20soft%20gradient%20background&width=800&height=1100&seq=comic-06&orientation=portrait',
    description: '朝鲜王朝时期，倾城倾国的公主李华英为了拯救濒临灭亡的王国，不得不嫁给敌国的王子。在权谋与爱情的交织中，她凭借智慧与勇气，一步步改变了自己和整个国家的命运。',
    rating: 9.6,
    views: 1350000,
    chapters: 110,
    status: '连载中',
    tags: ['古风', '宫廷', '权谋', '恋爱'],
    updated: '2026-08-04',
    featured: true,
    trending: true,
  },
  {
    id: 7,
    title: '武神重生',
    author: '尹志勋',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20powerful%20martial%20artist%20with%20intense%20energy%20aura%2C%20dynamic%20action%20pose%2C%20epic%20martial%20arts%20theme%2C%20clean%20simple%20dark%20gradient%20background%2C%20action%20genre&width=800&height=1100&seq=comic-07&orientation=portrait',
    description: '一代武神在巅峰之战中陨落，却意外重生回到少年时代。带着前世的记忆与战斗经验，他誓要弥补所有遗憾，攀登至武道之巅，成为真正的天下第一。燃爆热血的武斗场面，不容错过！',
    rating: 9.2,
    views: 1120000,
    chapters: 156,
    status: '连载中',
    tags: ['重生', '武术', '热血', '升级'],
    updated: '2026-08-04',
    featured: true,
    trending: true,
  },
  {
    id: 8,
    title: '恋爱契约',
    author: '金多美',
    category: 'romance',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20couple%20signing%20a%20contract%20in%20a%20cozy%20cafe%2C%20romantic%20comedy%20vibe%2C%20warm%20lighting%2C%20clean%20simple%20soft%20gradient%20background%2C%20romance%20genre&width=800&height=1100&seq=comic-08&orientation=portrait',
    description: '为了应付家人的催婚，自由职业者韩智恩与大企业继承人车恩宇签订了一份假恋爱契约。为期三个月的契约恋爱，却在朝夕相处中不知不觉变成了真心。但当契约到期时，他们能否坦诚面对彼此的感情？',
    rating: 9.3,
    views: 870000,
    chapters: 72,
    status: '已完结',
    tags: ['契约恋爱', '都市', '甜宠', '治愈'],
    updated: '2026-07-20',
    featured: false,
    trending: true,
  },
  {
    id: 9,
    title: '魔王的继承者',
    author: '宋智浩',
    category: 'fantasy',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20young%20man%20with%20demonic%20powers%20surrounded%20by%20dark%20energy%2C%20gothic%20fantasy%20atmosphere%2C%20clean%20simple%20dark%20gradient%20background%2C%20dark%20fantasy%20genre&width=800&height=1100&seq=comic-09&orientation=portrait',
    description: '平凡高中生李贤宇在某天突然被告知自己是魔王的继承者。为了不被光明势力消灭，他必须在魔界学院中学习掌控黑暗力量，同时隐藏自己的真实身份。黑暗奇幻与校园生活的完美结合！',
    rating: 9.1,
    views: 650000,
    chapters: 58,
    status: '连载中',
    tags: ['黑暗奇幻', '校园', '超能力', '成长'],
    updated: '2026-08-03',
    featured: false,
    trending: false,
  },
  {
    id: 10,
    title: '深夜食堂',
    author: '郑秀晶',
    category: 'drama',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20cozy%20late%20night%20restaurant%20with%20warm%20lighting%2C%20chef%20cooking%20behind%20counter%2C%20nostalgic%20atmosphere%2C%20clean%20simple%20soft%20gradient%20background%2C%20slice%20of%20life%20genre&width=800&height=1100&seq=comic-10&orientation=portrait',
    description: '在城市一角有一家只在深夜营业的小食堂。每一位深夜到访的客人都带着自己的故事——失意的上班族、迷茫的学生、孤独的老人。一道道暖心料理，串联起都市夜归人们的喜怒哀乐。',
    rating: 9.5,
    views: 720000,
    chapters: 40,
    status: '连载中',
    tags: ['美食', '治愈', '都市', '人生'],
    updated: '2026-08-01',
    featured: false,
    trending: false,
  },
  {
    id: 11,
    title: '异能特工队',
    author: '安在旭',
    category: 'action',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20team%20of%20superpowered%20agents%20in%20tactical%20gear%2C%20dynamic%20group%20pose%2C%20urban%20action%2C%20clean%20simple%20gradient%20background%2C%20superhero%20action%20genre&width=800&height=1100&seq=comic-11&orientation=portrait',
    description: '五个拥有特殊能力的年轻人被招募进国家秘密组织「异能特工队」，他们的任务是处理超自然事件和保护国家安全。但当他们发现组织的真实目的后，一切都变得不一样了。',
    rating: 9.0,
    views: 580000,
    chapters: 66,
    status: '连载中',
    tags: ['超能力', '特工', '团队', '动作'],
    updated: '2026-08-02',
    featured: false,
    trending: false,
  },
  {
    id: 12,
    title: '鬼医传说',
    author: '梁世宗',
    category: 'thriller',
    cover: 'https://readdy.ai/api/search-image?query=A%20Korean%20manhwa%20style%20illustration%20of%20a%20mysterious%20doctor%20in%20a%20dimly%20lit%20medical%20room%20with%20eerie%20atmosphere%2C%20horror%20medical%20thriller%2C%20clean%20simple%20dark%20gradient%20background&width=800&height=1100&seq=comic-12&orientation=portrait',
    description: '天才外科医生白承宇拥有一项特殊能力——他可以看到死者临终前的最后记忆。凭借这个能力，他暗中协助警方破获多起悬案，但这一次的案件，却与他失踪多年的妹妹有关。',
    rating: 9.4,
    views: 810000,
    chapters: 52,
    status: '连载中',
    tags: ['医学', '悬疑', '超能力', '推理'],
    updated: '2026-08-04',
    featured: false,
    trending: true,
  },
];

export const chapters = [
  { comicId: 1, number: 1, title: '死刑执行前', date: '2026-01-15' },
  { comicId: 1, number: 2, title: '回到过去', date: '2026-01-22' },
  { comicId: 1, number: 3, title: '新的开始', date: '2026-01-29' },
  { comicId: 1, number: 4, title: '第一个目标', date: '2026-02-05' },
  { comicId: 1, number: 5, title: '暗中布局', date: '2026-02-12' },
  { comicId: 1, number: 6, title: '仇人相见', date: '2026-02-19' },
  { comicId: 1, number: 7, title: '真相碎片', date: '2026-02-26' },
  { comicId: 1, number: 8, title: '意外的盟友', date: '2026-03-05' },
];

export const reviews = [
  { name: '漫画爱好者小陈', rating: 5, content: '画风超精美！剧情也很紧凑，每集结尾都让人迫不及待想看下一章。韩漫网更新速度也很快，强烈推荐！', date: '2026-08-01' },
  { name: '深夜读者', rating: 5, content: '看过很多韩漫网站，韩漫网的体验是最好的。界面干净清爽，加载速度快，而且漫画资源很全。', date: '2026-07-28' },
  { name: '小太阳', rating: 4, content: '收藏了好多喜欢的漫画，希望以后能增加更多完结作品。客服态度很好，有问题都能及时回复。', date: '2026-07-25' },
  { name: '追漫达人阿杰', rating: 5, content: '从朋友那边听说韩漫网的，一试就停不下来。分类很清晰，找漫画很方便，阅读体验也很流畅。', date: '2026-07-20' },
  { name: '星月夜', rating: 5, content: '韩漫网真的是宝藏平台！不仅漫画多，而且翻译质量很高。推荐给了很多朋友，大家都说好用！', date: '2026-07-15' },
];